export const businessData = {
  name: "Royal Prime Labels",
  url: "https://royalprimelabels.com",
  logo: "https://royalprimelabels.com/images/horizontal-logo.png",
  contact: {
    phoneDisplay: "+91 70279 80279",
    phoneLink: "+917027980279",
    email: "info@royalprimelabels.com"
  },
  address: {
    line1: "Plot 1455, HSIIDC Rai Industrial Area, Phase-1, Sector-38,",
    line2: "Sonepat, Haryana 131029,",
    country: "India",
    fullDisplay: "Plot 1455, HSIIDC Rai Industrial Area, Phase-1, Sector-38, Sonepat, Haryana 131029, India",
    street: "Plot 1455, HSIIDC Rai Industrial Area, Phase-1, Sector-38",
    city: "Sonepat",
    state: "Haryana",
    zip: "131029",
    mapsLink: "https://www.google.com/maps/place/ROYAL+PRIME+LABELS/@28.9291021,77.0865832,3a,75y,336.02h,131.32t/data=!3m7!1e1!3m5!1swvVHvPgA7gFGN3jrZBqN_w!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D-41.32026866097786%26panoid%3DwvVHvPgA7gFGN3jrZBqN_w%26yaw%3D336.0202439944305!7i13312!8i6656!4m7!3m6!1s0x390daef33894555f:0x72414be7599124c1!8m2!3d28.9292316!4d77.0866093!10e5!16s%2Fg%2F11s8c1jjqz?entry=ttu"
  },
  sydneyAddress: {
    line1: "Unit 24/457 Victoria Street Wetherill Park,",
    line2: "Sydney NSW-2164,",
    country: "Australia",
    fullDisplay: "Unit 24/457 Victoria Street Wetherill Park, Sydney NSW-2164, Australia",
    street: "Unit 24/457 Victoria Street Wetherill Park",
    city: "Sydney",
    state: "NSW",
    zip: "2164",
    mapsLink: "https://www.google.com/maps/search/?api=1&query=Unit+24%2F457+Victoria+Street+Wetherill+Park+Sydney+NSW-2164+Australia",
    embedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.1207869680373!2d150.9029437!3d-33.847952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b129759d57a22ef%3A0xe54d306b997c6d66!2sUnit%2024%2F457%20Victoria%20St%2C%20Wetherill%20Park%20NSW%202164%2C%20Australia!5e0!3m2!1sen!2sau!4v1718000000000!5m2!1sen!2sau"
  },
  founded: "1998",
  expertise: [
    "Flexographic printing",
    "Pharma label manufacturing",
    "FMCG labels",
    "Security labels",
    "Custom packaging labels"
  ],
  socials: {
    facebook: "https://www.facebook.com/royalprimelabels",
    linkedin: "https://www.linkedin.com/company/royal-prime-labels",
    instagram: "https://www.instagram.com/royalprimelabels"
  }
};
